export function addToPropertyMaps(propertyMaps, canvasId, properties) {
  const update = { ...propertyMaps };
  update[canvasId] = properties.reduce((acc, p) => {
    acc[p.name] = p;
    return acc;
  }, {});

  return update;
}
